import { render, staticRenderFns } from "./contentUserGroupCreate.vue?vue&type=template&id=17f96b99&"
import script from "./contentUserGroupCreate.vue?vue&type=script&lang=js&"
export * from "./contentUserGroupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports